module.exports = __webpack_public_path__ + "img/公众号.b6d99fab.jpg";